import { render, staticRenderFns } from "./View0.vue?vue&type=template&id=c888654a&scoped=true&"
import script from "./View0.vue?vue&type=script&lang=js&"
export * from "./View0.vue?vue&type=script&lang=js&"
import style0 from "./View0.vue?vue&type=style&index=0&id=c888654a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c888654a",
  null
  
)

export default component.exports